module.exports = __webpack_public_path__ + "static/media/habitpatter.48e8d4ee.png";